define(['jquery', 'c21/ajax'], function ($, ajax) {
   "use strict";

   var DEFAULT_RPP = 10,
      self = {},
      oDefaultParams = {};

   function initializePage() {
      initializeDefaultParams();
      bindSearchBox();
      bindLanguageSearch();
      bindDetailPages();
      renderTopPaginator();
      renderLowerPaginator();
      resizeAllCards();
      $(window).off(".agentRosterResize").on("resize.agentRosterResize", resizeAllCards);
   }

   function parseStartParam (strStart) {
      var iStart = parseInt(strStart);

      if (isNaN(iStart)) {
         return 0;
      }

      if (iStart < 0) {
         return 0;
      }

      return iStart;
   }

   function initializeDefaultParams() {
      oDefaultParams = {
         na: $("#roster-query").val(),
         start: $("#roster-start").val(),
         la: $("#roster-languages").val(),
         alpharange: $("#roster-alpharange").val()
      };

      oDefaultParams.start = parseStartParam(oDefaultParams.start);
   }

   function bindSearchBox() {
      var jInput = $("#agent-search-input"),
          jButton = $("#agent-search-submit");

      jButton.click(submitSearch);
      jInput.keydown(function(e) {
         if (e.which === 13) {
            submitSearch();
         }
      });
   }

   function submitSearch() {
      var jInput = $("#agent-search-input");
      ajax.gotoPageUrl(generateUrl({
         start: null,
         na: jInput.val(),
         alpharange: null
      }));
   }

   function bindLanguageSearch() {
      var aSelected = oDefaultParams.la.split(','),
          jBox = $("#language-options"),
          ajCheck = jBox.find(".language-option input"),
          jButton = $("#done-button-container .btn"),
          jLanguageFilterDisplay = $(".language-filter-display"),
          jLanguageClear = jLanguageFilterDisplay.children(".language-clear"),
          jLanguageLabel = jLanguageFilterDisplay.children(".language-label");

      jBox.click(function(e) {
         e.stopPropagation();
      });

      jButton.click(function() {
         var sLa = '';

         // bind listner to DONE button - only submit on change
         $.each(ajCheck.filter(':checked'), function(i, elCheck) {
            if (sLa) {
               sLa += ',';
            }
            sLa += $(elCheck).val();
         });
         if (sLa !== oDefaultParams.la) {
            ajax.gotoPageUrl(generateUrl({
               start: null,
               alpharange: null,
               la: sLa
            }));
         }
      });
      if (!aSelected.length || (aSelected.length === 1 && !aSelected[0])) {
         jLanguageFilterDisplay.hide();
      } else {
         var sLabel = '';
         jLanguageClear.click(function() {
            ajax.gotoPageUrl(generateUrl({
               start: null,
               la: null
            }));
         });
         for (var j = 0; j < aSelected.length; j++) {
            if (sLabel) {
               sLabel += ', ';
            }
            sLabel += $("#language-label-" + aSelected[j]).text();
         }
         jLanguageLabel.text(sLabel);
      }

      // select already checked boxes
      $.each(ajCheck, function(i, elCheck) {
         for (var j = 0; j < aSelected.length; j++) {
            var iVal = elCheck.value;
            if (aSelected[j] === iVal) {
               elCheck.checked = 'checked';
            }
         }
      });
   }

   function resizeCard(jCardLeft, jCardRight) {
      // Reset heights
      jCardLeft.css("height", "");
      jCardRight.css("height", "");

      // Determine new min height
      var iLeftHeight = jCardLeft.height(),
         iRightHeight = jCardRight.height();
      //Very aggresive height setting required for IE9
      if (iLeftHeight >= iRightHeight) {
         jCardRight.height(iLeftHeight);
         jCardLeft.height(iLeftHeight);
         return;
      }

      if( iRightHeight > iLeftHeight) {
         jCardLeft.height(iRightHeight);
         jCardRight.height(iRightHeight);
      }
   }

   function resizeAllCards () {
      var jCards = $(".agentContainer"),
         jCardLeft,
         jCardRight,
         i;

      // If in desktop mode, where agent cards
      // are displayed side-by-side
      if ($(window).width() > 767) {
         for (i = 0; i < jCards.length; i += 2) {
            // Resize the smaller card to have the height
            // of the larger card
            // (Fix for CEN-2219)
            jCardLeft = jCards.eq(i);
            jCardRight = jCards.eq(i + 1);
            resizeCard(jCardLeft, jCardRight);
         }
      } else {
         jCards.css("height", "");
      }
   }

   function bindDetailPages() {
      var ajAgents = $(".agentCard"),
          jDetails = $("#agent-roster-detail-card");

      var strLang = "";
      ajAgents.click(function() {
         var jThis = $(this);
         $.get(strLang + "/eco/roster/detail", {id: jThis.data("agent-id")}, function(data) {
            ajAgents.removeClass('selected');
            jThis.addClass('selected');
            $('.agent-detail-container', jDetails).html(data[0].html);
            $($('.agentCard.selected ~ .clearfix:visible')[0]).after(jDetails);
            $(window).off('.agentRoster').on('resize.agentRoster', function () {
               $($('.agentCard.selected ~ .clearfix:visible')[0]).after(jDetails);
            });
            jDetails.show();
            $(window).scrollTop(jThis.offset().top);
         });
      });
   }

   function renderTopPaginator() {
      var jParent = $("#agent-sort-buttons"),
//          sSortType = $("#roster-sort-type").val(),
          iMax = $("#roster-matching-agents").val();

//      switch (sSortType) {
//         case 'name':
//            // server handles this
//            $("#roster-pagination-"+oDefaultParams.alpharange).addClass('active');
//            break;
//         default:
            if (iMax > DEFAULT_RPP) {
               for (var i = 0; i < iMax; i += DEFAULT_RPP) {
                  var jButton = $('<a class="btn btn-default">'),
                     sLabel = (i + 1);
                  if (iMax > (i + 1)) {
                     sLabel += ('-' + Math.min(i + 10, iMax));
                  }
                  jButton.text(sLabel);
                  jButton.attr('href', generateUrl({start: i}));
                  if (i === oDefaultParams.start) {
                     jButton.addClass('active');
                  }
                  jParent.append(jButton);
               }
//            }
//            break;
      }
   }

   function generateUrl(oOptions) {
      var sBaseUrl = $("#roster-root-url").val();

      return sBaseUrl + '?' + $.param($.extend({}, oDefaultParams, oOptions));
   }

   function renderLowerPaginator() {
      var jParent = $("#agent-pager").children(".pagination"),
          iMax = $("#roster-matching-agents").val(),
          bLastActive = true,
          jButton;

      if (oDefaultParams.start !== 0) {
         jButton = $('<a class="btn btn-default">&lt;&lt;</a>');
         jButton.attr('href', generateUrl({start: oDefaultParams.start - parseInt(DEFAULT_RPP)}));
         jParent.append(jButton);
      }
      if (iMax > DEFAULT_RPP) {
         for (var i = 0; i < iMax; i += DEFAULT_RPP) {
            var sLabel = (i + 1);
            jButton = $('<a class="btn btn-default">');
            if (iMax > (i + 1)) {
               sLabel += ('-' + Math.min(i + 10, iMax));
            }
            jButton.text(i / DEFAULT_RPP + 1);
            jButton.attr('href', generateUrl({start: i}));
            if (i === oDefaultParams.start) {
               jButton.addClass('active');
               bLastActive = true;
            } else {
               bLastActive = false;
            }
            jParent.append(jButton);
         }
      }
      if (!bLastActive) {
         jButton = $('<a class="btn btn-default">&gt;&gt;</a>');
         jButton.attr('href', generateUrl({start: oDefaultParams.start + parseInt(DEFAULT_RPP)}));
         jParent.append(jButton);
      }
   }

   self.initialize = function() {
      initializePage();
   };

   return self;
});
